var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { ArrayMinSize, IsArray, IsBoolean, IsDateString, IsEnum, IsNumber, IsOptional, IsString, IsUUID, ValidateNested, } from 'class-validator';
import { TreatmentLocation } from '../../calls/enums/treatment-location.enum.js';
export class CreateAppointmentFromPlanSlotDto {
    scheduledStart;
    plannedDuration;
    billableServiceItemIds;
    therapistId;
    roomId;
    deviceIds = [];
    officeLocationId;
    treatmentLocation;
    service;
    description;
    /**
     * The scheduler placed this slot by hand rather than taking it from the slot
     * search (#1936). Every other slot is re-checked against the therapist's
     * availability before anything is booked, and a slot taken since the search
     * refuses the whole batch with `409 SLOT_TAKEN` + `takenStarts`. A slot set
     * by hand is not re-checked, so a deliberate double booking stays possible.
     */
    setByHand;
}
__decorate([
    IsDateString(),
    __metadata("design:type", Date)
], CreateAppointmentFromPlanSlotDto.prototype, "scheduledStart", void 0);
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateAppointmentFromPlanSlotDto.prototype, "plannedDuration", void 0);
__decorate([
    IsArray(),
    IsUUID('4', { each: true }),
    ArrayMinSize(1),
    __metadata("design:type", Array)
], CreateAppointmentFromPlanSlotDto.prototype, "billableServiceItemIds", void 0);
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], CreateAppointmentFromPlanSlotDto.prototype, "therapistId", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    __metadata("design:type", Object)
], CreateAppointmentFromPlanSlotDto.prototype, "roomId", void 0);
__decorate([
    IsArray(),
    IsUUID('4', { each: true }),
    IsOptional(),
    __metadata("design:type", Array)
], CreateAppointmentFromPlanSlotDto.prototype, "deviceIds", void 0);
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], CreateAppointmentFromPlanSlotDto.prototype, "officeLocationId", void 0);
__decorate([
    IsEnum(TreatmentLocation),
    __metadata("design:type", String)
], CreateAppointmentFromPlanSlotDto.prototype, "treatmentLocation", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], CreateAppointmentFromPlanSlotDto.prototype, "service", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], CreateAppointmentFromPlanSlotDto.prototype, "description", void 0);
__decorate([
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], CreateAppointmentFromPlanSlotDto.prototype, "setByHand", void 0);
export class CreateAppointmentsFromPlanDto {
    treatmentPlanId;
    slots;
}
__decorate([
    IsUUID(),
    __metadata("design:type", String)
], CreateAppointmentsFromPlanDto.prototype, "treatmentPlanId", void 0);
__decorate([
    IsArray(),
    ArrayMinSize(1),
    ValidateNested({ each: true }),
    Type(() => CreateAppointmentFromPlanSlotDto),
    __metadata("design:type", Array)
], CreateAppointmentsFromPlanDto.prototype, "slots", void 0);
//# sourceMappingURL=create-appointments-from-plan.dto.js.map